export function getReplyCommentParams(data, storyId, parentId) {
  return {
    ...data,
    body: data.reply,
    commentable_type: 'Story',
    commentable_id: storyId,
    parent_id: parentId
  };
}

export function getAnnotationParams(targetIds) {
  return {
    target_id: targetIds,
    target_type: 'Content'
  };
}

export const commentSort = (comments) => {
  comments.sort((a, b) => {
    let date1;
    let date2;

    if (a.children.length > 0) {
      date1 = a.children[a.children.length - 1].updatedAt
    } else {
      date1 = a.updatedAt
    }

    if (b.children.length > 0) {
      date2 = b.children[b.children.length - 1].updatedAt
    } else {
      date2 = b.updatedAt
    }

    return new Date(date2) - new Date(date1);
  })
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/utils.js